import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-900">
      <h1 className="text-4xl font-bold text-gray-800 dark:text-white">404 - Not Found</h1>
      <p className="mt-4 text-gray-600 dark:text-gray-300">
        You are not authorized to view this page.
      </p>
      <Link
        to="/login"
        className="mt-6 inline-block px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
      >
        Go to Login
      </Link>
    </div>
  );
};

export default NotFound;
